import { observer } from "mobx-react"
import React from "react"
import theme from "./theme"

@observer
export class NotReadyMessage extends React.Component<{
  model: { message: string }
}> {
  render() {
    const { model } = this.props

    return React.createElement(
      "div",
      {
        id: "not-ready",
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: window.innerWidth > 500 ? "65vh" : "80vh",
          minWidth: "55vw",
          maxWidth: window.innerWidth > 1023 ? "55vw" : "100%",
          maxHeight: window.innerHeight > 1023 ? "65vh" : "100%"
        }
      },
      React.createElement(
        "span",
        {
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.colors.black,
            minWidth: "55vw",
            textAlign: "center",
            alignSelf: "center",
            color: "white",
            fontSize: window.innerWidth > 450 ? "2rem" : "1rem",
            letterSpacing: window.innerWidth > 450 ? 10 : 2,
            lineHeight: 1.25,
            fontFamily: theme.fonts.secondary,
            textTransform: "uppercase",
            margin: "auto"
          }
        },
        React.createElement(
          "h2",
          { className: "has-text-weight-bold", style: { margin: "5%" } },
          model.message
        )
      )
    )
  }
}
